import { safeParse, safeParseNullDefault } from 'shouldve-been-js';

class Token {

    private _token: string | null;
    private _email: string | null;
    private _customerId: number | null;
    private _access: string[] | null;
    private _expiration: Date | null;

    public constructor(token: string | null, email: string | null, customerId: number | null, access: string[] | null, expiration: Date | null) {

        this._token = token;
        this._email = email;
        this._customerId = customerId;
        this._access = access;
        this._expiration = expiration;
    }

    public get token(): string | null {
        return this._token;
    }

    public set token(value: string | null) {
        this._token = value;
    }

    public get email(): string | null {
        return this._email;
    }

    public set email(value: string | null) {
        this._email = value;
    }

    public get customerId(): number | null {
        return this._customerId;
    }

    public set customerId(value: number | null) {
        this._customerId = value;
    }

    public get access(): string[] | null {
        return this._access;
    }

    public set access(value: string[] | null) {
        this._access = value;
    }

    public get expiration(): Date | null {
        return this._expiration;
    }

    public set expiration(value: Date | null) {
        this._expiration = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): Token | null {

        const token: string | null = safeParseNullDefault<string>(json?.data?.token, '');
        const email: string | null = safeParseNullDefault<string>(json?.data?.email, '');
        const customerId: number | null = safeParseNullDefault<number>(json?.data?.customerId, 0);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
        const access: any = json?.data?.access ?? null;
        const isSystemAccount: boolean = safeParse<boolean>(json?.data?.isSystemAccount, true);

        if (isSystemAccount) {
            return null;
        }

        let isAllStrings: boolean = false;

        if (Array.isArray(access)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            isAllStrings = access.every((element: any) => typeof element === 'string');
        }
       
        const expirationMillis: number | null = safeParseNullDefault<number>(json?.data?.exp, 0);
        const expiration: Date | null = expirationMillis === null ? null : new Date(expirationMillis);

        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        return new Token(token, email, customerId, isAllStrings ? access : null, expiration);
    }
}

export default Token;